<template>
  <div class='card' v-if="loaded">
    <h4 class='card-header'>
      <slot name='title'> E-mail Verification {{ verified ? "Successful" : "Unsuccessful" }} </slot>
    </h4>
    <div class='card-body'>
      <div class="form-group row" v-if="!verified">
        <div class='col-sm-12'>
          <div class="alert alert-danger">
            <div v-if="tokenExpired">
              <i class="fa fa-exclamation-triangle"></i>It seems your verification token has expired, please click on the button below to resend verification email
            </div>
            <div v-else-if="tokenError">
              <i class="fa fa-exclamation-triangle"></i>Your verification token is invalid, you may try resending verification email by clicking on the button below
            </div>
            <div v-else>
              <i class="fa fa-exclamation-triangle"></i>Something went wrong with your email verification, you may try resending verification email by clicking on the button below
            </div>
          </div>
        </div>

        <div class='col-sm-12'>
          <router-link
            :to="{ path: '/resendVerification' }"
            class="btn btn-info"
            style="color:white; margin-top:10px">
            <i :class="'fa fa-share fa-fw'"></i> Re-Send
          </router-link>
        </div>
      </div>
      <div class="form-group row" v-else>
        <div class='col-sm-12'>
          <p> Great! you have successfully verified your account </p>
          <router-link
            :to="{ path: '/login' }"
            class="btn btn-success btn-lg"
            style="color:white; margin-top:10px">
            <i :class="'fa fa-sign-in-alt fa-fw'"></i> Login
          </router-link>
        </div>
      </div>
    </div>
  </div>

</template>



<script>
import Api from '@/vuex/api'
import {
  OPEN_ERROR_MODAL
} from '@/vuex/types'

export default {
  name: 'EmailVerification',
  props: {
    options: {
      type: Object,
      default () {
        return {
          permalink: false,
          title: 'Loading ...'
        }
      }
    }
  },
  data () {
    return {
      tokenExpired: false,
      tokenError: false,
      verified: false,
      loaded: false
    }
  },
  async mounted () {
    try {
      const api = new Api()
      let response = await api.verifyEmail(this.$route.params.token)
      this.loaded = true
      if (response.data.result.message === 'Success') {
        this.verified = true
      } else if (response.data.result.errName === 'TokenExpiredError') {
        this.tokenExpired = true
      } else if (response.data.result.errName === 'JsonWebTokenError') {
        this.tokenError = true
      }
      await this.$nextTick()
    } catch (err) {
      this.$store.dispatch(OPEN_ERROR_MODAL, err)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailVerification.vue